<template>
  <div class="pd-bottom">
    <section class="bg-gradient pd-both container"
      v-for="tag in tags"
      :key="tag.id"
    >
      <h2 class="row-title1"
        @click.prevent="navigatorPush('Tag', { id: tag.id, title: tag.name })"
      >{{ tag.name }} <span class="small">{{ tag.context }}</span></h2>
      <div class="scroll-x-box">
        <ul class="inline-list no-bullet">
          <li class="js-newpage"
            v-for="channel in tag.channels"
            :key="channel.id"
          >
            <a class="" href=""
              @click.prevent="navigatorPush('Channel', { id: channel.id, title: channel.title })"
            >
              <img-with-placeholder class="round-sm" :src="constants.phImg300x300" :data-src="sizeImg(channel.image_base_url, 300, 300)" :alt="channel.image.alt_text" />
            </a>
            <div class="txt">
              <h3 class="h3"><a href=""
                @click.prevent="navigatorPush('Channel', { id: channel.id, title: channel.title })"
              >{{ channel.title }}</a></h3>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['tags'],
};
</script>
